require('./styles.scss');

var Top = require('./js/Index.js');
var Navigation = require('./js/navigation/Index.js');

module.exports = {Top, Navigation};



// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/webpack.dist.js